import { AiFillEdit, AiFillEye, AiFillDelete } from "react-icons/ai"; // Added AiFillDelete
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { BsArrowUpShort } from "react-icons/bs";
import TableHeaderCell from "components/reusable/TableHeaderCell";

// Added handleDelete to props
const SalaryLists = ({ subscriptionList, handleEdit, handleView, handleDelete, sort, setSort }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto relative rounded-lg border">
          <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
            <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
              <tr key="header">
                <TableHeaderCell text={t("EMPLOYEE_ID")} />
                <TableHeaderCell text={t("EMPLOYEE_NAME")} />
                <TableHeaderCell text={t("TOTAL_ALLOWANCE")} />
                <TableHeaderCell text={t("TOTAL_DEDUCTION")} />
                <TableHeaderCell text={t("NET_SALARY")} />

                <th
                  scope="col"
                  className="py-3 px-6 cursor-pointer"
                  onClick={() => {
                    if (sort.sortBy === "createdAt" && sort.sortType === "asc") {
                      setSort({
                        sortBy: "createdAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortBy: "createdAt",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>Created Date</span>
                    <span>
                      {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                      {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180" />}
                    </span>
                  </div>
                </th>
                <TableHeaderCell text={t("DEPARTMENT")} />
                <TableHeaderCell text={t("DURATION_TYPE")} />
                <th scope="col" className="py-3 px-6 text-center">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>

            <tbody>
              {subscriptionList &&
                subscriptionList?.map((item, i) => {
                  return (
                    <>
                      <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <td className="py-4 px-6 border-r text-gray-900">{item?.Employee?.employeeId}</td>
                        <td className="py-4 px-6 border-r text-gray-900">{item?.Employee?.name}</td>
                        <td className="py-4 px-6 border-r text-gray-900">${item?.totalAllowance}</td>
                        <td className="py-4 px-6 border-r text-gray-900">${item?.totalDeduction}</td>
                        <td className="py-4 px-6 border-r text-gray-900">${item?.totalAllowance - item?.totalDeduction}</td>
                        <td className="py-4 px-6 border-r text-gray-900">{dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")} </td>
                        <td className="py-4 px-6 border-r text-gray-900">{item?.Department?.name}</td>
                        <td className="py-4 px-6 border-r text-gray-900">{item?.JobRequests?.duration}</td>

                        <td className="py-4 px-6 border-r text-gray-900">
                          <div className="">
                            <ul className="flex justify-center items-center gap-1">
                              <li onClick={() => handleEdit(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                                <a title="Edit salary" className="hover:text-blue-700 transition duration-150 ease-in-out" data-bs-toggle="tooltip">
                                  {" "}
                                  <AiFillEdit className="cursor-pointer w-5 h-5 text-slate-600" />
                                </a>
                              </li>

                              <li onClick={() => handleView(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                                <a title="View salary">
                                  {" "}
                                  <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                                </a>
                              </li>
                              
                              {/* NEW DELETE BUTTON */}
                              <li onClick={() => handleDelete(item)} className="px-2 py-2 hover:bg-red-50 rounded">
                                <a title="Delete salary">
                                  <AiFillDelete className="cursor-pointer w-5 h-5 text-red-500" />
                                </a>
                              </li>

                            </ul>
                          </div>
                        </td>
                      </tr>
                    </>
                  );
                })}
              {isEmpty(subscriptionList) ? (
                <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
                  <td className="py-4 px-6 border-r" colSpan={12}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SalaryLists;